let resumeData = {
  imagebaseurl: 'https://www.linkedin.com/in/mehdi-rahal-abdelaziz/',
  name: 'Mehdi Rahal',
  role: 'Full Stack Developer',
  linkedinId: ' https://www.linkedin.com/in/mehdi-rahal-abdelaziz/',
  resumeLink:
    'https://drive.google.com/drive/folders/1gq-9aKUCUFoaPPxSh12XI0Ft8Fci_F4P?usp=sharing',
  skypeid: 'Your skypeid',
  roleDescription:
    " Ready to bring your vision to life. Check out my projects and experience. If you're ready to collaborate, reach out!",
  socialLinks: [
    {
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/mehdi-rahal-abdelaziz/',
      className: 'fa fa-linkedin',
    },
    {
      name: 'github',
      url: 'https://github.com/Mehdi-Rh',
      className: 'fa fa-github',
    },
    {
      name: 'skype',
      url: 'https://twitter.com/MRahal92',
      className: 'fa fa-twitter',
    },
  ],
  aboutme:
    'Experienced Full Stack Developer specializing in the JavaScript and TypeScript ecosystem. Proficient in building end-to-end web applications using Next.js, React, Node.js, and Express. Skilled in translating Figma designs into dynamic, responsive interfaces with React, MUI, and Tailwind CSS. Adept at managing state and data flow using Redux, React Query, and React Hooks. Experienced with RESTful APIs, MongoDB, and PostgreSQL for scalable backend solutions. Agile and Git proficient, ensuring smooth collaboration and CI/CD workflows. Thrives on tackling complex performance and architecture challenges, consistently delivering clean, maintainable, and high-performing solutions.',
  address: 'Algeria',
  website: 'https://mehdi-rahal-az.netlify.app/', // Todo
  education: [
    {
      UniversityName: 'Microverse Bootcamp',
      specialization: 'Full Stack Development',
      MonthOfPassing: 'October',
      YearOfPassing: '2022',
      Achievements: [
        'Spent 1300+ hours mastering algorithms, data structures, and front-end development while simultaneously developing projects with JavaScript, React, and Redux.',
        'Developed skills in remote pair-programming using GitHub, industry-standard git-flow, and daily standups to communicate and collaborate with international remote developers. ',
      ],
    },
    {
      UniversityName: 'University of Science and Technology of Oran - Mohamed Boudiaf',
      specialization: 'Master Degree in Electronic Engineering',
      MonthOfPassing: 'Sep',
      YearOfPassing: '2015',
      Achievements: ['Deployed a VoIP project: Commissioning the SIP protocol'],
    },
  ],
  work: [
    {
      CompanyName: 'Oreni',
      specialization: 'Founding Engineer',
      MonthOfLeaving: 'Present',
      YearOfLeaving: '',
      Achievements: [
        'AI Content Pipeline: Architected the YouTube-to-course generation pipeline using Gemini 2.5 Flash, including transcript ingestion, structure generation, and a 3-layer content-safety classifier.',
        'Full-Stack Development: Built the platform end-to-end on Next.js (App Router) and Supabase — auth, per-user course persistence, progress tracking, and admin tooling.',
        'Payment Integration: Led integration of Lemon Squeezy for subscriptions and per-course purchases, including webhook verification, entitlement grants, and refund handling.',
        'Credit-Based Metering System: Designed a credit-based generation quota system to control AI cost exposure while preserving user experience, replacing an earlier duration-cap model.',
        'Security Hardening: Identified and fixed a live Row-Level Security (database access-control) gap exposing unauthenticated write access to a production table.',
        'Analytics Integration: Implemented PostHog for product analytics, including client/server identity merging and privacy-compliant data handling.',
        'Cost & Reliability Controls: Built a daily AI-spend circuit breaker and global concurrency limiter to prevent runaway API costs.',
        'Admin Panel Development: Built a role-gated admin dashboard for user/course management, content moderation, and feature-flag control.',
        'Database Architecture: Designed and maintained the Supabase schema across 100+ migrations, managing staging/production parity.',
        'Retention Systems: Built automated email workflows (due-card reminders, resume nudges, weekly digests) via cron jobs and transactional email.',
        'Legal & Compliance: Authored privacy/cookie policy updates to keep disclosures aligned with new tracking integrations.',
      ],
    },
    {
      CompanyName: 'Lablabee',
      specialization: 'React Frontend Developer',
      MonthOfLeaving: 'Oct',
      YearOfLeaving: '2025',
      Achievements: [
        'SPA Development: Contributed to the development of a Telco Cloud training web app using React, Redux, and Material UI.',
        'Enhanced User Experience: Optimized and refactored the Web App and elevated its user satisfaction and functionality.',
        'Code Refactoring Expertise: Led strategic code refactoring initiatives to enhance maintainability and adhere to best practices, reducing technical debt.',
        'Modular Components: Created reusable components using React design patterns, bolstering modularity and agility.',
        'Agile Collaboration: Powered teamwork through Slack and version control with GitLab for efficient project execution and issue resolution.',
        'Precise Task Management: Managed tasks effectively in Jira, ensuring on-time deliverables aligned with project objectives.',
        'Code Excellence: Translated complex designs into high-quality code, maintaining design integrity.',
        'Proactive Technical Debt Management: Addressed technical debt proactively, elevating code quality and resilience.',
        'Comprehensive Code Reviews: Led thorough code reviews for uniformity and minimized post-release issues.',
        'Quality Assurance: Ensured high-quality releases through exhaustive UI and functionality testing.',
        'Deadline-Driven: Consistently met tight deadlines, contributing to project success and client satisfaction.',
      ],
    },
    {
      CompanyName: 'Microverse',
      specialization: 'Front End Developer',
      MonthOfLeaving: 'Oct',
      YearOfLeaving: '2021',
      Achievements: [
        'Spent 1300+ hours mastering algorithms, data structures, and front-end development while simultaneously developing projects with JavaScript and React.',
        'Mastered intermediate and advanced topics in front-end development (including React, Git, and DS&A challenges) while building multiple front-end projects independently and via pair programming',
        'Developed skills in remote pair-programming using GitHub, industry-standard gitflow, and daily standups to communicate and collaborate with international remote developers. ',
        'Mentored junior web developers, providing technical support through code reviews.',
      ],
    },
  ],
  skillsDescription: 'Your skills here',
  skills: {
    'tools-frameworks': [
      {
        skillname: 'Reactjs',
        image: 'images/skills/react js.svg',
      },
      {
        skillname: 'Typescript',
        image: 'images/skills/typescript.svg',
      },

      {
        skillname: 'Redux',
        image: 'images/skills/redux.svg',
      },
      {
        skillname: 'Material-UI',
        image: 'images/skills/material-ui.svg',
      },
      {
        skillname: 'Tailwind',
        image: 'images/skills/tailwind.svg',
      },
      {
        skillname: 'Bootstrap',
        image: 'images/skills/bootstrap.svg',
      },
      {
        skillname: 'Git',
        image: 'images/skills/git.svg',
      },
      {
        skillname: 'VsCode',
        image: 'images/skills/vscode.svg',
      },
    ],
  },
  portfolio: [
    {
      name: 'Oreni',
      description:
        'AI-powered platform that turns YouTube videos into structured online courses, with built-in progress tracking and content moderation.',
      imgurl: 'images/myImages/screenshots/Portfolio-5.png',
      liveUrl: 'https://oreni.co',
      skills: ['Next.js', 'Supabase', 'Google AI Studio', 'Lemon Squeezy', 'PostHog'],
    },
    {
      name: 'LabLabee',
      description: 'B2B Telco Cloud training platform',
      imgurl: 'images/myImages/screenshots/Portfolio-1.png',
      demoUrl: 'https://www.youtube.com/watch?v=jEniF78rD7E&t=226s&ab_channel=ApisTraining',
      skills: ['Javascript', 'React', 'Redux', 'Material-UI'],
    },

    {
      name: 'AI Research Explorer',
      description:
        'AI Research Explorer - a web application that allows users to search, analyze, and interact with research content using AI capabilities.',
      imgurl: 'images/myImages/screenshots/Portfolio-3.png',
      liveUrl: 'https://ai-research-explorer-psi.vercel.app/',
      sourceUrl: 'https://github.com/Mehdi-Rh/AI-Research-Explorer?tab=readme-ov-file',
      skills: ['React', 'Typescript', 'Material UI', 'Cohere AI'],
    },
    {
      name: 'Bookit Mern',
      description:
        'This is a learning portfolio project where I converted the Booking App built by Brad (owner of Traversy Media) from NextJS to a MERN-based project to sharpen my skills in this stack. Guest credentials: email: guest@example.com password: guest@example.com2025CAP',
      imgurl: 'images/myImages/screenshots/Bookit.png',
      demoUrl: 'https://bookit-mern-c3pj.onrender.com/',
      sourceUrl: 'https://github.com/Mehdi-Rh/Bookit-Mern',
      skills: [
        'Javascript',
        'React',
        'Express',
        'MongoDb',
        'Cloudinary',
        'React-Router',
        'Tailwind',
      ],
    },
  ],
  testimonials: [
    {
      description: 'This is a sample testimonial',
      name: 'Some technical guy',
    },
    {
      description: 'This is a sample testimonial',
      name: 'Some technical guy',
    },
  ],
};

export default resumeData;
